<script>
import deepLink from '@/mixins/deeplink.js'

export default {
  name: 'ButtonDeeplinkWithIconText',
  mixins: [deepLink()],
  props: {
      componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      text: ' text'
    }
  },
  computed: {
    getText() {
      return this.componentData.text || "Let's continue the conversation in WhatsApp"
    },
    getWhatsAppIcon() {
      return this.componentData.icon || 'https://img.rappi.com/support/icons/screens6_0/whatsapp-icon.png'
    },
    getDeepLink() {
      return this.componentData.buttonDeepLink || 'whatsapp://send?phone=+5541707535'
    }
  },
  methods: {
    redirectToWhatsApp() {
      this.thirdPartyDeepLink(this.getDeepLink)
    }
  }
}
</script>

<template>
  <section :class="$style.container">
    <section
      :class="$style.container__content"
      @click="redirectToWhatsApp">
      <aside :class="$style.container__content__icon" >
        <i>
          <img
            :src="getWhatsAppIcon"
            alt="whatsapp icon"
            loading="lazy"
            width="20" >
        </i>
      </aside>
      <p :class="$style.container__content__text">
        {{ getText }}
      </p>
    </section>
  </section>
</template>


<style lang="scss" scoped module>
@import '@design';

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    cursor: pointer;

    &__icon {
      padding: 0 .5rem;
    }

    &__text {
      @extend %typography-small;
      color: $rappi-green;
      text-decoration: underline;
      margin: 0;
      font-weight: bold;
    }
  }
}

</style>
